/** Diagnósticos (1.0 AdminDiagnostics): errores del cliente con ruta, migas y traza; 30 días. */
import { useEffect, useState, type ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@nuvvu/shared/api';
import type { DiagnosticRow } from '@nuvvu/shared/api';
import { call, errorText } from '../api.js';
import { btn, card, field, muted, Notice } from '../lib/ui.js';

const when = (ms: number | null): string => (ms ? new Date(ms).toLocaleString('es') : '—');

export function DiagnosticsPage(): ReactElement {
  const [items, setItems] = useState<DiagnosticRow[] | null>(null);
  const [kind, setKind] = useState<'' | 'error' | 'boundary' | 'manual'>('');
  const [uid, setUid] = useState('');
  const [open, setOpen] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const load = (): void => {
    call(api.admin.diagnostics, {
      limit: 100,
      ...(kind ? { kind } : {}),
      ...(uid.trim() ? { uid: uid.trim() } : {}),
    })
      .then((r) => {
        setItems(r.items);
      })
      .catch((e: unknown) => {
        setError(errorText(e));
      });
  };
  useEffect(load, [kind]);
  return (
    <>
      <h1 style={{ margin: 0 }}>Diagnósticos del cliente</h1>
      <p style={muted}>
        Errores no capturados en la web (window.onerror, promesas) con las últimas migas de
        navegación. Máximo 5 por sesión del navegador y 20 por persona cada 15 min; se borran a los
        30 días.
      </p>
      <Notice text={error} error />
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        {(['', 'error', 'boundary', 'manual'] as const).map((k) => (
          <button
            key={k || 'all'}
            type="button"
            style={btn(kind === k)}
            onClick={() => {
              setKind(k);
            }}
          >
            {k || 'Todos'}
          </button>
        ))}
        <input
          style={{ ...field, maxWidth: 280 }}
          placeholder="uid"
          value={uid}
          onChange={(e) => {
            setUid(e.target.value);
          }}
        />
        <button type="button" style={btn(false)} onClick={load}>
          Filtrar
        </button>
      </div>
      {!items && !error && <p style={muted}>Cargando…</p>}
      {items?.length === 0 && <p style={muted}>Sin diagnósticos.</p>}
      {items?.map((d) => (
        <section key={d.id} style={{ ...card, gap: 6 }}>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
            <strong>{d.kind}</strong>
            <span style={muted}>
              {when(d.created_ms)} · {d.platform} · {d.route || '—'} · {d.context || '—'} ·{' '}
              {d.uid ? <Link to={`/usuarios/${d.uid}`}>usuario</Link> : 'anónimo'}
            </span>
            <button
              type="button"
              style={{ ...btn(false), marginLeft: 'auto' }}
              onClick={() => {
                setOpen(open === d.id ? null : d.id);
              }}
            >
              {open === d.id ? 'Cerrar' : 'Detalle'}
            </button>
          </div>
          <p style={{ margin: 0, fontSize: 13, whiteSpace: 'pre-wrap' }}>{d.message}</p>
          {open === d.id && (
            <div style={{ fontSize: 12, display: 'grid', gap: 6 }}>
              <span style={muted}>{d.user_agent ?? ''}</span>
              {d.breadcrumbs.length > 0 && (
                <ol style={{ margin: 0, paddingLeft: 18 }}>
                  {d.breadcrumbs.map((b, i) => (
                    <li key={i}>
                      {when(b.t)} — {b.msg}
                    </li>
                  ))}
                </ol>
              )}
              {d.stack && (
                <pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: 11 }}>{d.stack}</pre>
              )}
            </div>
          )}
        </section>
      ))}
    </>
  );
}
